/**
 * Barra de metas del carrito (snippets/mr-tiers.liquid).
 *
 * Liquid pinta el estado inicial. Este elemento repinta el mensaje, el
 * relleno y las metas cuando cambia data-subtotal (en céntimos), que lo
 * actualizan «Arma tu kit» y la ficha de producto.
 */
class MrTiers extends HTMLElement {
  static observedAttributes = ['data-subtotal'];

  connectedCallback() {
    this.#render();
  }

  attributeChangedCallback() {
    if (this.isConnected) this.#render();
  }

  #render() {
    const subtotal = Number(this.dataset.subtotal) || 0;
    const max = Number(this.dataset.max) || 0;
    if (!max) return;

    const stops = [...this.querySelectorAll('[data-mrt-stop]')].filter((stop) => stop instanceof HTMLElement);
    let next = null;

    for (const stop of stops) {
      const value = Number(stop.dataset.value) || 0;
      const done = subtotal >= value;
      stop.classList.toggle('is-done', done);
      if (!done && !next) next = stop;
    }

    const fill = this.querySelector('[data-mrt-fill]');
    if (fill instanceof HTMLElement) fill.style.width = `${Math.min(100, (subtotal / max) * 100)}%`;

    const msg = this.querySelector('[data-mrt-msg]');
    if (!msg) return;

    msg.replaceChildren();
    if (!next) {
      msg.textContent = this.dataset.done ?? '';
      return;
    }

    const missing = this.#money((Number(next.dataset.value) || 0) - subtotal);
    const [before, ...rest] = (next.dataset.text ?? '').split('[importe]');
    msg.append(before);
    if (rest.length) {
      const strong = document.createElement('strong');
      strong.textContent = missing;
      msg.append(strong, rest.join('[importe]'));
    }
  }

  /**
   * Formatea con el patrón de la tienda (formatos con coma o punto decimal).
   *
   * @param {number} cents
   */
  #money(cents) {
    const format = this.dataset.moneyFormat ?? '{{amount}}';
    const withComma = format.includes('amount_with_comma_separator');
    const number = (Math.max(0, cents) / 100).toLocaleString(withComma ? 'es-ES' : 'en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return format.replace(/\{\{\s*amount[^}]*\}\}/, number);
  }
}

if (!customElements.get('mr-tiers')) {
  customElements.define('mr-tiers', MrTiers);
}
